import type { Recommendation } from '../../types';

export interface RecommendationFormField {
  name: string;
  value: string;
}

/**
 * Maps a recommendation card to the hidden form field the subscribe action reads.
 * The three kinds of card subscribe the visitor through different backend paths:
 *
 * - newsletter list  → `newsletter_list_ids[]`  (opt into one of the current pub's lists)
 * - owned publication → `publication_ids[]`      (subscribe to another pub in the org)
 * - network rec       → `recommendation_ids[]`   (subscribe via the recommendation)
 */
export const getRecommendationFormField = (recommendation: Recommendation): RecommendationFormField => {
  if (recommendation.newsletter_list_id) {
    return { name: 'newsletter_list_ids[]', value: recommendation.newsletter_list_id };
  }

  if (recommendation.isOwner) {
    return { name: 'publication_ids[]', value: recommendation.recommended_publication_id };
  }

  return { name: 'recommendation_ids[]', value: recommendation.id };
};
